export const LOGO = 'https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png';

export const API_OPTIONS = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJlZDg1ZTkzNGRlMDM3OGQwNzhkZWMyM2YzMjc2NjkyZCIsInN1YiI6IjY1Y2E1N2U2YTkzZDI1MDE4NDRlZTI3NyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.6S79a6qgUHe0eGvjUkJjNbr93K3lBPlhXn1GfEdKL6M'
    }
};

export const IMG_CDN_URL = "https://image.tmdb.org/t/p/w500";